module.exports = __webpack_public_path__ + "static/media/IE.34a9b58d.svg";